import * as React from 'react'

import { Label } from 'main/ui'
import {
  Container,
  RadioButtonsContainer,
  RadioLabel,
  StyledRadioInput,
  ValidationHint,
} from './RadioGroup.styles'

interface IOption {
  label: string
  value: string
}

interface IProps {
  label: React.ReactNode
  value: string
  options: IOption[]
  disabled: boolean
  inline: boolean
  invalid: boolean
  validationHint?: string
  onChange: (value: string) => void
}

RadioGroup.defaultProps = {
  disabled: false,
  inline: false,
  invalid: false,
}

function RadioGroup(props: IProps) {
  const invalid = props.invalid || !!props.validationHint

  return (
    <Container>
      <Label>{props.label}</Label>
      {renderValidationHintMaybe(props, invalid)}
      <RadioButtonsContainer inline={props.inline}>
        {renderRadios(props, invalid)}
      </RadioButtonsContainer>
    </Container>
  )
}

function renderRadios(props: IProps, invalid: boolean) {
  return props.options.map(option => {
    return (
      <RadioLabel disabled={props.disabled} inline={props.inline} key={option.value}>
        <StyledRadioInput
          type="radio"
          invalid={invalid}
          value={option.value}
          checked={props.value === option.value}
          disabled={props.disabled}
          onChange={() => handleChange(option.value, props)}
        />
        {option.label}
      </RadioLabel>
    )
  })
}

function handleChange(value: string, props: IProps) {
  props.onChange(value)
}

function renderValidationHintMaybe(props: IProps, invalid: boolean) {
  if (!invalid) return null

  return <ValidationHint>{props.validationHint}</ValidationHint>
}

export default React.memo(RadioGroup)
